import { IFavorite } from '../../../types/favorites';
import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EGetFavoritesListActionTypes, TGetFavoritesListSucceed } from './types';

export const getFavoritesListSucceed: (notifications: IFavorite[]) => TGetFavoritesListSucceed = actionGenerator<
  EGetFavoritesListActionTypes.Succeed,
  IFavorite[]
>(EGetFavoritesListActionTypes.Succeed);
